<template>
	<div class="contact-result ">
	  	<div class="panel panel-default">
	  		<div class="panel-heading dash-bg-color-skin-light-10">
	    		<div class="col-xs-2 pull-left align-left head-left">
	    			<div class="rec"></div>
	    			<i class="fa fa-chevron-left back-mb cursor-pointer" aria-hidden="true" @click="toggle('list')"></i>
	    		</div>
	    		<div class="col-xs-8 pull-left align-center head-center">
	    			<div class="contactlabel"> {{ labels[nowLang].contactLabel }} </div>
	    		</div>
	    		<div class="col-xs-2 pull-right align-right">
	    		</div>
	    	</div>

		    <div class="panel-body">
		    	<div class="back-for-pc" v-show="pcDisp">
		            <i class="fa fa-chevron-left cursor-pointer" @click="toggle('list')"></i>
		         </div>
		   		<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12">
                    <template v-if="contact.image_path !== ''">
                      <img class="img-circle" :src="baseURL + contact.image_path + '?' + (Math.random() * 100)">
                    </template>
                    <template v-else>
                      <img class="img-circle" src="~static/images/employee/no_image.png">
                    </template>
					<contact-fav v-model="contact.codempfav" :postContactFavorite="postContactFavorite" :codempid="contact.codempid"></contact-fav>
				</div>
		    	<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12 center">
					<label class="name dash-color-skin">{{ contact.desc_codempid }}</label>
				</div>
		    	<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12 center">
					<label class="company">{{ contact.desc_codcomp }}</label>
				</div>
		    	<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12 center">
					<label class="position">{{ contact.desc_codpos }}</label>
				</div>
		    	<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12 centeri box-call">
		    		<span class="fa-stack fa-lg set-position-icon">
					  	<a v-if="Object(contact.numtelec).length == 1" class="disabled fa fa-circle-thin fa-stack-2x icon_dis dash-color-skin" ></a>
					  	<a :href="'tel:' + contact.numtelec" v-if="Object(contact.numtelec).length == 1" class="disabled fa fa-phone fa-stack-1x fa-inverse phone" ><label class="font_icon_dis">{{ labels[nowLang].call }}</label></a>
					    <!-- <a :href="'tel:' + contact.numtelec" class="fa fa-phone fa-stack-1x fa-inverse phone" ><label class="font_icon">Call</label></a> -->
					  	<a v-if="Object(contact.numtelec).length > 1 " class="fa fa-circle fa-stack-2x icon dash-color-skin" ></a>
			 			<a :href="'tel:' + contact.numtelec" v-if="Object(contact.numtelec).length > 1 " class="fa fa-phone fa-stack-1x fa-inverse phone" ><label class="font_icon">{{ labels[nowLang].call }}</label></a>
					</span>
		    		<span class="fa-stack fa-lg set-position-icon">
					  	<a v-if="Object(contact.email).length == 1" class="disabled fa fa-circle-thin fa-stack-2x icon_dis dash-color-skin" ></a>
					  	<a :href="'mailto:' + contact.email" v-if="Object(contact.email).length == 1" class="disabled fa fa-envelope fa-stack-1x fa-inverse " ><label class="font_icon_dis">{{ labels[nowLang].mail }}</label></a>
					  	<!-- <a :href="'mailto:' + contact.email" class="fa fa-envelope fa-stack-1x fa-inverse " ><label class="font_icon">Mail</label></a> -->
					  	<a v-if="Object(contact.email).length > 1 " class="fa fa-circle fa-stack-2x icon dash-color-skin" ></a>
			 			<a :href="'mailto:' + contact.email" v-if="Object(contact.email).length > 1 " class="fa fa-envelope fa-stack-1x fa-inverse " ><label class="font_icon">{{ labels[nowLang].mail }}</label></a>
					</span>
				</div>
		    	<!-- <hr> -->
				<!-- Telephone work  -->
		    	<div class="row phone_display" v-if="Object(contact.numtelof).length == 1" >
				</div>
		    	<div class="row" v-if="Object(contact.numtelof).length > 1 ">
			    	<div class="col-xs-2">
			    		<span class="glyphicon glyphicon-phone-alt icon2"></span>
					</div>
			    	<div class="col-xs-10">
						<label class="position">{{ labels[nowLang].work }}</label><br>
						<label class="detail">{{ contact.numtelof }}</label>
					</div>
				</div>
				<!-- Phone number -->
		    	<div class="row phone_display" v-if="Object(contact.numtelec).length == 1" >
				</div>
		    	<div class="row" v-if="Object(contact.numtelec).length > 1 ">
			    	<div class="col-xs-2">
			    		<span class="fa fa-mobile icon3"></span>
					</div>
			    	<div class="col-xs-10">
						<label class="position">{{ labels[nowLang].mobile }}</label><br>
						<label class="detail">{{ contact.numtelec }}</label>
					</div>
				</div>
				<!-- Email -->
		    	<div class="row phone_display" v-if="Object(contact.email).length == 1" >
				</div>
		    	<div class="row" v-if="Object(contact.email).length > 1 ">
			    	<div class="col-xs-2">
			    		<span class="fa fa-envelope icon2"></span>
					</div>
			    	<div class="col-xs-10">
						<label class="position">{{ labels[nowLang].email }}</label><br>
						<label class="detail">{{ contact.email }}</label>
					</div>
				</div>
		    </div>
	  	</div>
	</div>
</template>

<script>
import contactFav from 'components/contact/contactFav'

export default {
  name: 'contact-detail',
  props: [ 'labels', 'contact', 'toggle', 'pcDisp', 'postContactFavorite', 'nowLang', 'baseURL' ],
  components: {
    contactFav
  }
}
</script>



// WEBPACK FOOTER //
// contactDetail.vue?2a49b871